import React from 'react';
import Header from './Header';
import MobileNav from './MobileNav';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main id="main-content" role="main" aria-label="Main content" className="pb-20 md:pb-0">
        {children}
      </main>
      <MobileNav />
    </div>
  );
};

export default Layout;